import { render } from "./dlistnumList.vue?vue&type=template&id=71427bdc&scoped=true"
import script from "./dlistnumList.vue?vue&type=script&lang=js"
export * from "./dlistnumList.vue?vue&type=script&lang=js"

import "./dlistnumList.vue?vue&type=style&index=0&id=71427bdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71427bdc"]])

export default __exports__